module.exports = __webpack_public_path__ + "img/DOGE.2e6c2f22.svg";